import { reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux'
import { fetchCustomers, fetchCustomerDetail } from '../../actions/customers_actions';
import { createDropship } from '../../actions/purchaseOrders_actions';
import CustomerInfo from '../../components/Purchase/customerInfo';

const customerInfo = reduxForm({
    form: 'customerInfo',
    validate
})(CustomerInfo);
const selector = formValueSelector('customerInfo')

const validate = values => {
  const errors = {}
  if (!values.Name) {
      errors.Name = 'Required'
  }
  if (!values.TermDays) {
      errors.TermDays = 'Required'
  } else if (isNaN(Number(values.TermDays))) {
      errors.TermDays = 'Term Days should be a number.'
  }
  if (!values.Termtype) {
      errors.Termtype = 'Required'
  }
  return errors
}

function mapStateToProps(state) {
    const deliver_Customer_id = selector(state, 'Deliver_Customer_id');
    return {
        deliver_Customer_id,
        currentPaymentTerm: state.paymentTerms.currentPaymentTerm,
        initialValues: state.paymentTerms.currentPaymentTerm,
        isCreating: state.paymentTerms.isCreating,
        createError: state.paymentTerms.createError,
        created: state.paymentTerms.created,
        isEditing: state.paymentTerms.isEditing,
        editError: state.paymentTerms.editError,
        edited: state.paymentTerms.edited,

        customers: state.customers.all,
        customersIsLoading: state.customers.isLoading,
        customersError: state.customers.error,
        currentCustomerDetail: state.customers.currentCustomerDetail,
        detailIsLoading: state.customers.detailIsLoading,
        detailError: state.customers.detailError,
        userPermissions: state.auth.userPermissions
    }

}

export default connect(mapStateToProps, { createDropship, fetchCustomers, fetchCustomerDetail })(customerInfo)



// WEBPACK FOOTER //
// ./master/jsx/containers/Purchase/customerInfo.jsx